export default {
  id: 'slack_custom',
  title: 'Custom message',
  type: 'Direct / Channel',
  canSendToChannel: true,
  description: 'Create a custom Slack message.',
  body: {
    blocks: [
      {
        text: {
          text: '[[INPUT_MESSAGE_TEXT]]',
          type: 'mrkdwn'
        },
        type: 'section'
      }
    ]
  },
  inputs: {
    INPUT_MESSAGE_TEXT: {
      label: 'Message Content',
      placeholder: 'Hi {{FIRST_NAME}}, ...',
      defaultValue: 'Hi {{FIRST_NAME}}, ...',
      type: 'HTML'
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/slack/picnic/custom.js